/**
 * DataSource-Registry und Sync-Protokoll.
 *
 * Die Registry beschreibt je Quelle Endpoint, Adapter, Sync-Rhythmus und
 * Lizenz/Attribution. Der (spätere) Sync-Job läuft die Registry ab; die
 * Admin-Sicht liest den Status über `sync`-Calls. v1 hat nur den
 * OParl-Adapter; weitere Quellen (CKAN, GTFS, DWD, ...) kommen als weitere
 * Registry-Einträge dazu — teils portal-übergreifend nutzbar.
 */
export var SyncRunStatus;
(function (SyncRunStatus) {
    SyncRunStatus["OK"] = "ok";
    SyncRunStatus["FEHLER"] = "fehler";
    SyncRunStatus["LAEUFT"] = "laeuft";
})(SyncRunStatus || (SyncRunStatus = {}));
// =============================================================================
// Call-Shapes (Admin, read-only)
// =============================================================================
export const SYNC_OBJECT = "sync";
//# sourceMappingURL=data-source-model.js.map